



















































/* General */
import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'
import {
  IBreadcrumbDataFromListing,
  INavMenuItem,
} from '@/types/data-objects/global'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'BreadcrumbForItemDetail',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },

    title: {
      type: String,
      default: '',
    },

    selectedEntityId: {
      type: Number,
      default: null,
    },

    itemRefNumber: {
      type: Number,
      default: null,
    },

    itemTitle: {
      type: String,
      default: '',
    },

    showItemTitle: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      defaultFilters: [] as INavMenuItem[],
      customFilters: [] as INavMenuItem[],
      currentFilter: {} as INavMenuItem,
    }
  },

  computed: {
    arrowClasses(): string {
      if (this.$screen.isTabletOrDesktop(this.$mq)) {
        return 'ddi ddi-caret-right'
      }
      return 'hidden'
    },
    fromAll(): boolean | any {
      return BreadcrumbAssistant.fromAll(this.$route, this.$store)
    },
    fromAllTasks(): boolean {
      return this.fromAll && this.entityType === EEntities.PROJECTS
    },
    fromAllConvos(): boolean {
      return this.fromAll && this.entityType === EEntities.MAILBOXES
    },
    fromEntityLanding(): boolean | any {
      return BreadcrumbAssistant.fromEntityLanding(this.$route, this.$store)
    },
    cachedBreadcrumbData(): IBreadcrumbDataFromListing {
      return BreadcrumbAssistant.lastVisitedBreadcrumbDataFromListing(
        this.$store,
      )
    },
    breadcrumbItems(): IBreadcrumbItemMenuItem[] {
      return BreadcrumbAssistant.lastVisitedBreadcrumbItemMenuItems(this.$store)
    },
    iconName(): string {
      if (this.fromAll) {
        return TextAssistant.itemSingularName(this.entityType).toLowerCase()
      }
      return TextAssistant.entitySingularName(this.entityType).toLowerCase()
    },
    previousItem(): IBreadcrumbItemMenuItem {
      return BreadcrumbAssistant.getPreviousBreadcrumbItem(
        this.itemRefNumber,
        this.$store,
      )
    },
    nextItem(): IBreadcrumbItemMenuItem {
      return BreadcrumbAssistant.getNextBreadcrumbItem(
        this.itemRefNumber,
        this.$store,
      )
    },
  },
})
